




















import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  Unit, PartnersApi, Partner,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';

@Component({
  components: {},
})
export default class PartnerList extends Vue {
  @Prop() public partners!: Partner;

  @Prop() public partnerActiveId!: Partner;

  @Prop() public unitIcon!: string;

  public async onChange(item: any) {
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const partnerUser = await api.getPartnerById(item.value);
      const { id } = partnerUser.data;
      if (id) {
        this.$emit('partnerData', id);
      }
    } catch (error) {
      console.log('err', error);
    }
  }
}
